import { ShoppingBag } from "lucide-react";

const CATEGORIES = [
  {
    slug: "hats",
    label: "Hats",
    tag: "COMING SOON",
    image:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_build-and-quote/artifacts/wsi5aw2t_ChatGPT%20Image%20Sep%2020%2C%202026%2C%2001_50_51%20AM.png",
  },
  {
    slug: "hoodies",
    label: "Hoodies",
    tag: "COMING SOON",
    image:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_build-and-quote/artifacts/fzbbrbt8_ChatGPT%20Image%20Sep%2020%2C%202026%2C%2001_51_10%20AM.png",
  },
  {
    slug: "shirts",
    label: "Shirts",
    tag: "COMING SOON",
    image:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_build-and-quote/artifacts/2397slzf_ChatGPT%20Image%20Sep%2020%2C%202026%2C%2001_58_25%20AM.png",
  },
];

export default function Merch() {
  return (
    <section
      id="merch"
      data-testid="merch-section"
      className="py-24 lg:py-32 border-t border-neutral-900"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="font-mono-label text-[11px] text-neutral-500 mb-4">
              03 · Merch
            </p>
            <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter max-w-2xl">
              Wear the mark.
            </h2>
          </div>
          <p className="text-neutral-400 max-w-sm">
            Coming soon.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 lg:gap-6">
          {CATEGORIES.map((c) => (
            <div
              key={c.slug}
              data-testid={`merch-card-${c.slug}`}
              className="group relative overflow-hidden border border-neutral-900 aspect-[4/5] bg-neutral-950"
            >
              <img
                src={c.image}
                alt={c.label}
                className="w-full h-full object-contain bg-white group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute top-4 left-4">
                <span className="font-mono-label text-[9px] tracking-[0.28em] bg-[#F5F5F0] text-black px-2 py-1">
                  {c.tag}
                </span>
              </div>
              <div className="absolute bottom-6 left-6 right-6">
                <p className="font-display font-black text-3xl md:text-4xl tracking-tighter text-[#F5F5F0] drop-shadow-[0_2px_8px_rgba(0,0,0,0.9)]">
                  {c.label}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#quote-form"
            data-testid="merch-notify-cta"
            className="inline-flex items-center gap-2 border border-[#F5F5F0] px-6 py-3 text-sm font-semibold text-[#F5F5F0] hover:bg-[#F5F5F0] hover:text-black transition-colors"
          >
            <ShoppingBag size={14} />
            Notify me when merch drops
          </a>
          <p className="text-xs text-neutral-500 font-mono-label">
            Or text 403-393-5772
          </p>
        </div>
      </div>
    </section>
  );
}
